import {
  Flex,
  Image,
  Text,
  Button,
  SimpleGrid,
  useBreakpointValue,
} from "@chakra-ui/react";
import Question from "../components/Question";

const Component = () => {
  const directionRight = useBreakpointValue({ base: "right", xl: "right" });
  const directionLeft = useBreakpointValue({ base: "right", xl: "left" });

  return (
    <Flex
      direction={"column"}
      gap={"40px"}
      width={"100%"}
      alignItems={"center"}
      mt={"130px"}
      mb={"130px"}
    >
      <Flex direction={"column"} align={"center"}>
        <Text fontSize={"42px"} lineHeight={"125%"}>
          NAJCZĘŚCIEJ
        </Text>
        <Text fontWeight={"600"} fontSize={"42px"} lineHeight={"125%"} textAlign={"center"}> 
          ZADAWANE PYTANIA
        </Text>
      </Flex>
      <SimpleGrid
        columns={{ base: 1, xl: 2 }}
        spacing={"10px"}
        width={"100%"}
        justifyItems={"center"}
        alignItems={"flex-start"}
      >
        <Question
          title={"Kto bierze czynny udział w projekcie?"}
          description={
            "Skład naszej ekipy można sprawdzić na serwerze discord. Każdy z nas wkłada serce i aktywnie uczestniczy w jego rozwoju. Jeśli masz odpowiednie umiejętności i zechcesz dołączyć do naszego zespołu, serdecznie zapraszamy do złożenia propozycji wraz z portfolio u jednego z Administratorów RCON."
          }
          rotation={directionRight == "right" ? "270deg" : "90deg"}
          direction={directionRight}
        />
        <Question
          title={"Kiedy odbędzie się planowany start serwera?"}
          description={
            "Nasz zespół w pełni wykorzystuje każdą dostępną chwilę, aby jak najszybciej przygotować serwer. Tworzenie serwera od podstaw wymaga wielkich pokładów energii i czasu. Wstępnie planujemy ukończyć serwer do końca tego roku, jednakże na obecną chwile nie jesteśmy w stanie niczego zagwarantować."
          }
          rotation={directionLeft == "right" ? "270deg" : "90deg"}
          direction={directionLeft}
        />
        <Question
          title={"Czy planowane są beta testy przed oficjalnym startem serwera?"}
          description={
            "Ze względu na ilość osób zaangażowanych w projekt na ten moment nie planujemy beta testów. Jesteśmy przekonani, że sami uporamy się z większością błędów, jeśli jednak zadanie nas przerośnie to otworzymy rekrutację na beta testerów."
          }
          rotation={directionRight == "right" ? "270deg" : "90deg"}
          direction={directionRight}
        />
        <Question
          title={"W jakich lokalizacjach planowana jest rozgrywka?"}
          description={
            "Pierwszymi lokalizacjami dostępnymi po starcie serwera będzie miasto Los Santos oraz okoliczne wioski. Wraz z rozwojem serwera pozostała część mapy również będzie dostępna dla graczy."
          }
          rotation={directionLeft == "right" ? "270deg" : "90deg"}
          direction={directionLeft}
        />
      </SimpleGrid>
    </Flex>
  );
};

export default Component;
